const orderStatuses = [
  "pending",
  "confirmed",
  "preparing",
  "ready",
  "completed",
  "cancelled",
  "refunded",
];

export default function OrderFilters({ filters, onFilterChange }) {
  return (
    <section className="card admin-panel">
      <header className="card-header">
        <h2>Filters</h2>
      </header>
      <div className="card-body form-row">
        <input
          placeholder="Customer or order number"
          value={filters.search || ""}
          onChange={(event) => onFilterChange({ search: event.target.value })}
        />

        <select
          value={filters.status || ""}
          onChange={(event) => onFilterChange({ status: event.target.value })}
        >
          <option value="">All statuses</option>
          {orderStatuses.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>

        <input
          type="date"
          value={filters.requested_date || ""}
          onChange={(event) => onFilterChange({ requested_date: event.target.value })}
        />
      </div>
    </section>
  );
}